<template>
  <div data-component-group="lists" data-component="invoice-lines">
    <slot name="beforeForm" />

    <v-list lines="two" class="invoice-lines-list">
      <template v-for="({ amount, service_description }) in items" :key="amount + service_description">
        <v-list-item>
          <AmountLabel label="Description" :value="service_description" />

          <AmountLabel
            label="Amount"
            :value="`${amount} ${currency.symbol}`"
          />
        </v-list-item>
      </template>
    </v-list>
  </div>
</template>

<script>
  import AmountLabel from '../labels/Amount';
  import { isObj, isStr, isNum } from '../../utils';

  export default {
    components: {
      AmountLabel,
    },
    props: {
      items: {
        type: Array,
        required: true,
        validator(value) {
          return value.every(
            (item) =>
              isObj(item) &&
              isStr(item.service_description) &&
              (isStr(item.amount) || isNum(item.amount)),
          );
        },
      },
      currency: {
        type: Object,
        required: true,
      },
    },
  };
</script>

<style lang="scss">
@use 'sass:map';
@use '../../assets/styles/theme' as *;

[data-component-group='lists'][data-component='invoice-lines'] {
  padding: $spacing-xl;
  background-color: rgb(var(--v-theme-surface));
  border-top: 1px solid map.get($colors, grey, lighten-2);

  .v-list-item {
    overflow-x: hidden;
    overflow-y: auto;
    border-radius: $border-radius;
    height: auto;
    padding: 0;
  }

  .invoice-line-item {
    padding: 0;
  }

  .v-list-item__content {
    padding: 0;
  }
}
</style>
